<template>
  <div id="app">
    <div class="feed-main">
      <div v-if="!loading">
        <div v-for="project in projects" :key="project.id">
          <project-info :project="project"/>
        </div>
      </div>
      <div v-if="loading" class="loader-div">
        <div class="spinner">
          <div class="rect1"></div>
          <div class="rect2"></div>
          <div class="rect3"></div>
          <div class="rect4"></div>
          <div class="rect5"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { get } from "axios";
import ProjectInfo from "./children/ProjectInfo";

export default {
  name: "MyProjects",
  components: {
    ProjectInfo
  },
  data() {
    return {
      projects: [],
      remainingGets: {},
      loading: false
    };
  },
  methods: {
    getRepos: function() {
      get("https://api.github.com/users/BorjaZarco/repos")
        .then(res => {
          this.remainingGets = res.headers["x-ratelimit-limit"];
          this.projects = res.data;
          this.loading = false;
        })
        .catch(err => {
          console.log(err);
          this.loading = false;
        });
    }
  },
  created() {
    this.loading = true;
    this.getRepos();
  }
};
</script>

<style scoped>
.feed-main {
  display: flex;
  justify-content: center;
}

.loader-div {
  display: flex;
  justify-content: center;
  align-items: center;
  grid-column: 2/3;
  height: 760px;
}

.spinner {
  margin: 100px auto;
  width: 50px;
  height: 40px;
  text-align: center;
  font-size: 10px;
}

.spinner > div {
  background-color: #333;
  height: 100%;
  width: 6px;
  display: inline-block;
  -webkit-animation: sk-stretchdelay 1.2s infinite ease-in-out;
  animation: sk-stretchdelay 1.2s infinite ease-in-out;
}

.spinner .rect2 {
  -webkit-animation-delay: -1.1s;
  animation-delay: -1.1s;
}

.spinner .rect3 {
  -webkit-animation-delay: -1s;
  animation-delay: -1s;
}

.spinner .rect4 {
  -webkit-animation-delay: -0.9s;
  animation-delay: -0.9s;
}

.spinner .rect5 {
  -webkit-animation-delay: -0.8s;
  animation-delay: -0.8s;
}

@-webkit-keyframes sk-stretchdelay {
  0%,
  40%,
  100% {
    -webkit-transform: scaleY(0.4);
  }
  20% {
    -webkit-transform: scaleY(1);
  }
}

@keyframes sk-stretchdelay {
  0%,
  40%,
  100% {
    transform: scaleY(0.4);
    -webkit-transform: scaleY(0.4);
  }
  20% {
    transform: scaleY(1);
    -webkit-transform: scaleY(1);
  }
}
</style>



// WEBPACK FOOTER //
// src/components/MyProjects.vue